module.exports = __webpack_public_path__ + "static/img/y8.751d90ed.svg";